'use strict';

httpInterceptorErrors.$inject = ["common", "config", "$q", "$state"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.httpInterceptorErrors = httpInterceptorErrors;
/*@ngInject*/
function httpInterceptorErrors(common, config, $q, $state) {
    return {
        responseError: function responseError(rejection) {

            if (rejection.status >= 400 && rejection.status < 500) {
                var clientError = 'The request was invalid or cannot be otherwise served [' + rejection.status + '].';
                // No longer threat 400 as exceptions
                trackJs.console.warn(clientError);
                //common.log.error(clientError);
                common.log.warn('HTTP client error ' + rejection.status);
                common.log.warn(rejection.data);
            }

            if (rejection.status >= 500) {
                //var serverError = 'Something is broken at the server [' + rejection.status + '].';
                trackJs.addMetadata('rejection data', rejection.config);
                //trackJs.track(serverError);
                common.log.error('HTTP server error ' + rejection.status);
                common.log.error(rejection.data);

                $state.go('error');
            }

            return $q.reject(rejection);
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/core/httpInterceptorErrors.js
// module id = 704
// module chunks = 0